import AuthSuccess from "./../auth-success";
import {useQuery} from "../../../helpers/hooks/common-hook";

export default function AuthCallback({authConfig}) {
    const query = useQuery();
    const code = query.get('code');
    return (
        <div className="px-2">
            <div className="flex flex-col">
                {code?
                    <AuthSuccess
                        authConfig={authConfig}
                        authInfo={{
                            code
                        }}
                    />
                :<div>Unable to login</div>}
            </div>
        </div>
    )
}